module.exports = __webpack_public_path__ + "static/media/YF06_3.92a74692.jpg";